const GET_NO_VALIDATED_RC_SCANNED_DOCUMENTS_REQUEST =
  'GET_NO_VALIDATED_RC_SCANNED_DOCUMENTS_REQUEST';
const GET_NO_VALIDATED_RC_SCANNED_DOCUMENTS_SUCCESS =
  'GET_NO_VALIDATED_RC_SCANNED_DOCUMENTS_SUCCESS';
const GET_NO_VALIDATED_RC_SCANNED_DOCUMENTS_ERROR =
  'GET_NO_VALIDATED_RC_SCANNED_DOCUMENTS_ERROR';
const CLEAR_NO_VALIDATED_RC_SCANNED_DOCUMENTS_STATE =
  'CLEAR_NO_VALIDATED_RC_SCANNED_DOCUMENTS_STATE';
const CLEAR_ERRORS = 'CLEAR_ERRORS';
const CLEAR_ERRORS_PROFILE = 'CLEAR_ERRORS_PROFILE';
const INIT_REDUCER = 'INIT_REDUCER';
const CREATE_ERRORS = 'CREATE_ERRORS';
const DELETE_NO_VALIDATED_RC_SCANNED_DOCUMENT_REQUEST =
  'DELETE_NO_VALIDATED_RC_SCANNED_DOCUMENT_REQUEST';
const DELETE_NO_VALIDATED_RC_SCANNED_DOCUMENT_SUCCESS =
  'DELETE_NO_VALIDATED_RC_SCANNED_DOCUMENT_SUCCESS';
const DELETE_NO_VALIDATED_RC_SCANNED_DOCUMENT_ERROR =
  'DELETE_NO_VALIDATED_RC_SCANNED_DOCUMENT_ERROR';

export {
  GET_NO_VALIDATED_RC_SCANNED_DOCUMENTS_REQUEST,
  GET_NO_VALIDATED_RC_SCANNED_DOCUMENTS_SUCCESS,
  GET_NO_VALIDATED_RC_SCANNED_DOCUMENTS_ERROR,
  DELETE_NO_VALIDATED_RC_SCANNED_DOCUMENT_REQUEST,
  DELETE_NO_VALIDATED_RC_SCANNED_DOCUMENT_SUCCESS,
  DELETE_NO_VALIDATED_RC_SCANNED_DOCUMENT_ERROR,
  CLEAR_NO_VALIDATED_RC_SCANNED_DOCUMENTS_STATE,
  CLEAR_ERRORS,
  CLEAR_ERRORS_PROFILE,
  CREATE_ERRORS,
  INIT_REDUCER,
};
